module.exports = __webpack_public_path__ + "154d58fb52dd5282886c99bb9886dd2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-s.png
// module id = 3336
// module chunks = 0